import promise from 'bluebird';
import {communityService} from "../_services";
import {ResponseFilter} from "../config/response-handler";

export const communityActions = {
    getCommunityPosts,
    publishCommunityPost,
    unpublishCommunityPost,
};

export const communityConstants = {
  GET_COMMUNITY_POSTS_REQUEST: "GET_COMMUNITY_POSTS_REQUEST",
  GET_COMMUNITY_POSTS_SUCCESS: "GET_COMMUNITY_POSTS_SUCCESS",
  GET_COMMUNITY_POSTS_ERROR: "GET_COMMUNITY_POSTS_ERROR",
  PUBLISH_COMMUNITY_POST_REQUEST: "PUBLISH_COMMUNITY_POST_REQUEST",
  PUBLISH_COMMUNITY_POST_SUCCESS: "PUBLISH_COMMUNITY_POST_SUCCESS",
  PUBLISH_COMMUNITY_POST_ERROR: "PUBLISH_COMMUNITY_POST_ERROR",
  UNPUBLISH_COMMUNITY_POST_REQUEST: "UNPUBLISH_COMMUNITY_POST_REQUEST",
  UNPUBLISH_COMMUNITY_POST_SUCCESS: "UNPUBLISH_COMMUNITY_POST_SUCCESS",
  UNPUBLISH_COMMUNITY_POST_ERROR: "UNPUBLISH_COMMUNITY_POST_ERROR",
};


function getCommunityPosts(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request(params));
            communityService.getCommunityPosts(params)
                .then(response => {
                    let {serverResponseData} = ResponseFilter(response);
                    resolve(serverResponseData);
                    dispatch(success(serverResponseData));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                })
        })
    };

    function request(getCommunityPostsRequest) {
        return {type: communityConstants.GET_COMMUNITY_POSTS_REQUEST, getCommunityPostsRequest}
    }
    function success(getCommunityPostsSuccess) {
        return {type: communityConstants.GET_COMMUNITY_POSTS_SUCCESS, getCommunityPostsSuccess}
    }

    function failure(getCommunityPostsFail) {
        return {type: communityConstants.GET_COMMUNITY_POSTS_ERROR, getCommunityPostsFail}
    }
}

function publishCommunityPost(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request(params));
            communityService.publishCommunityPost(params)
                .then(response => {
                    let {serverResponseData} = ResponseFilter(response);
                    resolve(serverResponseData);
                    dispatch(success(serverResponseData));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                })
        })
    };

    function request(publishCommunityPostRequest) {
        return {type: communityConstants.PUBLISH_COMMUNITY_POST_REQUEST, publishCommunityPostRequest}
    }
    function success(publishCommunityPostSuccess) {
        return {type: communityConstants.PUBLISH_COMMUNITY_POST_SUCCESS, publishCommunityPostSuccess}
    }
    function failure(publishCommunityPostFail) {
        return {type: communityConstants.PUBLISH_COMMUNITY_POST_ERROR, publishCommunityPostFail}
    }
}

function unpublishCommunityPost(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request(params));
            communityService.unpublishCommunityPost(params)
                .then(response => {
                    let {serverResponseData} = ResponseFilter(response);
                    resolve(serverResponseData);
                    dispatch(success(serverResponseData));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                })
        })
    };
    function request(unpublishCommunityPostRequest) {
        return {type: communityConstants.UNPUBLISH_COMMUNITY_POST_REQUEST, unpublishCommunityPostRequest}
    }
    function success(unpublishCommunityPostSuccess) {
        return {type: communityConstants.UNPUBLISH_COMMUNITY_POST_SUCCESS, unpublishCommunityPostSuccess}
    }
    function failure(unpublishCommunityPostFail) {
        return {type: communityConstants.UNPUBLISH_COMMUNITY_POST_ERROR, unpublishCommunityPostFail}
    }
}